import { CenterReplica } from "./CenterReplica.tsx";
import { HudReplica } from "./HudReplica.tsx";
import { SidebarReplica } from "./SidebarReplica.tsx";
import type { DemoTarget, ReplicaState } from "@/product-stage/demo/types.ts";

export function WorkbenchReplica({
  state,
  elapsed,
  onSelect
}: {
  state: ReplicaState;
  elapsed: number;
  onSelect(target: DemoTarget): void;
}) {
  return (
    <div className="replica" data-scene={state.sceneId} data-platform="darwin">
      <div className="workspace-body" data-agents={state.view === "files" ? "closed" : "open"}>
        <SidebarReplica state={state} onSelect={onSelect} />
        <CenterReplica state={state} elapsed={elapsed} onSelect={onSelect} />
        {state.view === "files" ? null : <HudReplica state={state} onSelect={onSelect} />}
      </div>
    </div>
  );
}
